/* app/js/src/components/scheduler/scheduler.component.scss */
.cursor-pointer {
  cursor: pointer;
}
div {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  position: relative;
}
icn-calendar,
icn-edit-graphics,
live,
icn-add-edit-stream {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.close-curtain {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: transparent;
  z-index: 2;
}
.upload-media-add-contract-modal {
  width: 383.9px;
  height: 207px;
  background-color: white;
  border-radius: 4px;
  border: solid 1px #e1e6eb;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  display: flex;
  padding-top: 30px;
  padding-left: 37.9px;
  padding-right: 17px;
  padding-bottom: 66px;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  left: 275px;
  top: 6%;
  z-index: 99;
}
.upload-media-add-contract-modal input {
  opacity: 0;
  cursor: pointer;
  position: absolute;
  right: 0;
  bottom: 0;
  margin: 0 10px 10px 0;
}
.triangle-with-shadow {
  width: 17px;
  height: 20px;
  position: absolute;
  overflow: hidden;
  left: -15px;
  top: 66px;
  background-color: transparent;
}
.triangle-with-shadow:after {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  transform: rotate(-45deg);
  left: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
}
.upload-media-add-contract-header {
  font-family: "Open Sans";
  font-size: 24px;
  color: #232f3a;
  line-height: 1;
  letter-spacing: 0.2px;
  margin-bottom: 3px;
}
.upload-media-add-contract-description {
  font-family: "Open Sans";
  font-size: 14px;
  color: #232f3a;
  line-height: 1.29;
  letter-spacing: 0.1px;
  margin-bottom: 16px;
}
.select-upload-or-add-container {
  width: 325px;
  display: flex;
  justify-content: space-between;
}
.select-header {
  font-family: "Open Sans";
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #7d8fa1;
  line-height: 30px;
  margin-right: 13px;
}
.select-upload-or-add-drowdown {
  flex-grow: 1;
  width: 272px;
}
.upload-add-button {
  width: 73px;
  height: 30px;
  border-radius: 4px;
  position: absolute;
  right: 0;
  bottom: 0;
  margin: 0 18px 18px 0;
  font-size: 13px;
  letter-spacing: 0.1px;
  color: #ffffff;
  background-color: #232f3a;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.upload-add-button + input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.add-contract-button {
  visibility: hidden;
}
.close-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  color: #879baf;
  cursor: pointer;
}
.showMenu {
  display: block;
}
.hideMenu {
  display: none;
}
/*# sourceMappingURL=scheduler.component.css.map */
